<div class="socials">
  <div class="socials__item">
    <button class="btn-main btn-secondary" [ngClass]="isLink ? 'btn-xs btn-border' : 'btn-xl google-btn'" [disabled]="disabled">
      {{ isLink ? ('actions.link' | translate) : ('auth.google_sign_in' | translate) }} <img src="./assets/images/google-icon.svg" alt="Google" />
    </button>
    <asl-google-signin-button width="400" shape="circle" size="large" locale="en" type="standard"></asl-google-signin-button>
  </div>
</div>
